/* home-actions.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./home-actions.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { HomeActionsAttachRef } from '../../context/home-actions/home-actions-context';
var styles = {
  root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
  logoPaddingStyles: "_pwyo12x7",
  contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};

/**
 * __Home actions__
 *
 * Wrapper for the top navigation actions on the inline-start (left) side of the top navigation.
 */
export var HomeActions = function HomeActions(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  var ref = useContext(HomeActionsAttachRef);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": testId,
    className: ax([styles.root, fg('platform_design_system_nav4_top_nav_min_widths') ? styles.contentMinWidthStyles :
    // Removing the extra logo padding when applying the content min width
    styles.logoPaddingStyles])
  }, children);
};